export default __webpack_public_path__ + "static/media/Web-popup-Banner.a05365fa.jpg";